// extracted by mini-css-extract-plugin
export default {"recommender":"tK-z","recommenderCard":"uK-z","recommendationsNotMobileBadge":"vK-z","rowHasBadge":"wK-z"};